export default {
  setUser(state, { user }) {
    state.token = user.token;
    // Read back what actions.js's Login just wrote to localStorage (the `user`
    // param here is actually the whole axios response, not response.data.data —
    // pre-existing shape, harmless since localStorage is the real source of truth).
    state.isAdmin = localStorage.getItem("is_admin") === "1";
    state.permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  },
  logout(state) {
    state.token = null;
    state.user  = null;
    state.isAdmin = false;
    state.permissions = [];
    localStorage.removeItem("token");
    localStorage.removeItem("is_admin");
    localStorage.removeItem("is_master");
    localStorage.removeItem("permissions");
  },
  setTheme(state, theme) {
    state.theme = theme;
    localStorage.setItem("portal_theme", theme);
  },
  setPermissions(state, { isAdmin, permissions }) {
    state.isAdmin = isAdmin;
    state.permissions = permissions;
  },
};
